import { z } from "zod";
const healthFields = {
    version: z.string().min(1),
    startedAt: z.string().datetime(),
    // Se le email di sistema partono davvero (piano M1b D10): senza, «Password dimenticata?» non promette un'email.
    emailDelivery: z.boolean(),
    // Se «Accedi con Google» c'è (AZI-11): soltanto con le due variabili `GOOGLE_OAUTH_*` e l'autenticazione; assente vale falso.
    googleSignIn: z.boolean().optional(),
};
// `200`: il server risponde e, se ha un database di piattaforma, quel database risponde a `select 1` (incidente del 18/10/2026).
// Senza database (M0, solo fuori produzione) `database` manca.
export const healthResponseSchema = z.object({ status: z.literal("ok"), ...healthFields, database: z.literal("ok").optional() });
// `503`: il server risponde ma il database di piattaforma no (errore o più di 2 secondi), con gli stessi campi.
export const healthDegradedResponseSchema = z.object({ status: z.literal("degraded"), ...healthFields, database: z.literal("down") });
//# sourceMappingURL=health.js.map